import React, { useState } from 'react';
import { Download, FileText, BarChart3 } from 'lucide-react';

const ExportButton = ({ onExport, onError, onSuccess }) => {
  const [isExporting, setIsExporting] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleExport = async (type) => {
    setIsExporting(true);
    setShowDropdown(false);
    
    try {
      await onExport(type);
      // Notificação removida
    } catch (error) {
      onError('Erro ao exportar dados');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        disabled={isExporting}
        className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isExporting ? (
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
        ) : (
          <Download className="w-4 h-4" />
        )}
        <span>{isExporting ? 'Exportando...' : 'Exportar'}</span>
      </button>

      {showDropdown && (
        <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg border border-gray-200 dark:border-gray-700 z-10">
          <div className="py-1">
            <button
              onClick={() => handleExport('messages')}
              className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <FileText className="w-4 h-4" />
              <span>Dados de Mensagens</span>
            </button>
            <button
              onClick={() => handleExport('campaigns')}
              className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <BarChart3 className="w-4 h-4" />
              <span>Dados de Campanhas</span>
            </button>
          </div>
        </div>
      )}

      {/* Overlay para fechar dropdown */}
      {showDropdown && (
        <div 
          className="fixed inset-0 z-0" 
          onClick={() => setShowDropdown(false)}
        ></div>
      )}
    </div>
  );
};

export default ExportButton;